module.exports = __webpack_public_path__ + "static/media/water-supply-3-bg.83f7a0ca.jpg";